import { AtButton, AtButtonState, AtButtonVariant, AtIcon } from '@curran-catalog/curran-atomic-library'
import { Cart } from 'types'

type OrderSummarySynsisalProps = {
  handleCheckoutClick: () => void
  isSubmitting: boolean
  cart?: Cart
}

const OrderSummarySynsisal = ({ handleCheckoutClick, cart, isSubmitting }: OrderSummarySynsisalProps) => {
  return (
    <section
      aria-labelledby="summary-heading"
      className="mt-16 bg-subdued px-4 py-6 sm:p-6 lg:col-span-5 lg:mt-0 lg:p-8"
    >
      <h2 id="summary-heading" className="text-lg font-medium text-gray-900">
        Order summary
      </h2>

      <dl className="mt-6 space-y-4">
        <div className="flex items-center justify-between">
          <dt className="text-sm text-gray-600">Subtotal</dt>
          <dd className="text-sm font-medium text-gray-900">
            {!cart || cart.isUpdatingTotals ? <AtIcon type="spinner" size={20} /> : 'Free'}
          </dd>
        </div>
        <div className="flex items-center justify-between border-t border-outlined-gray pt-4">
          <dt className="flex items-center text-sm text-gray-600">
            <span>Standard Shipping</span>
          </dt>
          <dd className="text-sm font-medium text-gray-900">
            {!cart || cart.isUpdatingTotals ? <AtIcon type="spinner" size={20} /> : 'Free - USPS'}
          </dd>
        </div>
      </dl>
      <div className="mt-6">
        <AtButton
          className="w-full"
          variant={AtButtonVariant.PRIMARY}
          onClick={handleCheckoutClick}
          label={isSubmitting ? 'Loading...' : 'Checkout'}
          state={isSubmitting ? AtButtonState.DISABLED : AtButtonState.ENABLED}
        />
      </div>
    </section>
  )
}

export default OrderSummarySynsisal
